import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function RowActions({ onEdit, onDelete, testIdPrefix }) {
  const stop = (e) => e.stopPropagation();
  return (
    <div onClick={stop} className="inline-block">
      <DropdownMenu>
        <DropdownMenuTrigger
          data-testid={`${testIdPrefix}-actions-trigger`}
          className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-[#5C635A] hover:bg-[#F2F0EA] hover:text-[#1A1D1A] transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#4A5D4E]"
        >
          <MoreHorizontal strokeWidth={1.5} size={18} />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="bg-white border-[#E5E2DC] rounded-lg"
          onClick={stop}
        >
          <DropdownMenuItem
            onClick={(e) => {
              stop(e);
              onEdit?.();
            }}
            data-testid={`${testIdPrefix}-edit-action`}
            className="cursor-pointer focus:bg-[#F2F0EA] text-[#1A1D1A]"
          >
            <Pencil strokeWidth={1.5} size={14} />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={(e) => {
              stop(e);
              onDelete?.();
            }}
            data-testid={`${testIdPrefix}-delete-action`}
            className="cursor-pointer focus:bg-[#9C6A53]/10 text-[#9C6A53]"
          >
            <Trash2 strokeWidth={1.5} size={14} />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
